import Loader from "./Loader";
export default function PageLoader() {
  return (
    <div className="loader text-center">
      <Loader className="spinner-border-lg" />
    </div>
  );
}
